module.exports = () => `
  {
    sustainabilityPage {
      locations {
        id
        title
        teaser
        teaserImageUrl
        position
        city
        type
      },
      features {
        id
        title
        text
      }
      intro {
        id
        title
        text
      }
      locationIntro {
        id
        title
        text
      }
    }
  }
`
